import React, { FC } from 'react';
import FreeCreditsHistoryDialogView from './FreeCreditsHistoryDialogView';
import { useFreeCreditsHistoryDialogController } from '../../../controllers';
import { FreeCreditsHistoryDialogProps } from '../../../types';

const FreeCreditsHistoryDialog: FC<FreeCreditsHistoryDialogProps> = props => {
  const viewModel = useFreeCreditsHistoryDialogController(props);
  return <FreeCreditsHistoryDialogView {...viewModel} />;
};

export default FreeCreditsHistoryDialog;
